import classes from './adminSviKorisnici.module.css'
import useAxiosPrivate from '../hooks/useAxiosPrivate'
import { useQuery } from '@tanstack/react-query'
import AdminSingleUser from './AdminSingleUser'
import Spinner from '../components/Spinner'
import { useState } from 'react'

const SviKorisnici = () => {
  const [search, setSearch] = useState('')

  const axiosPrivate = useAxiosPrivate()
  const getAllUsers = async () => {
    const { data } = await axiosPrivate.get('/user/getAllUsers')
    data.allUsers.map((user) => {
      user.paidToDate = new Date(user.paidToDate).getTime()
      return user
    })
    return data
  }
  const allUsersQuery = useQuery({
    queryKey: ['users'],
    queryFn: () => getAllUsers(),
    staleTime: 0,
    refetchInterval: 1000 * 60 * 60 * 12,
  })
  if (allUsersQuery.isError) return <h2>Error...</h2>

  const filteredUsers =
    (allUsersQuery.data?.allUsers &&
      allUsersQuery.data?.allUsers.filter((user) => {
        const name = user.userName?.toLowerCase() || ''
        const email = user.email?.toLowerCase() || ''
        const searchTerm = search.toLowerCase()
        return name.includes(searchTerm) || email.includes(searchTerm)
      })) ||
    []

  return (
    <div className={classes.container}>
      {allUsersQuery.isLoading ? (
        <Spinner />
      ) : (
        <>
          <h1>Svi Korisnici</h1>
          <div className={classes.top}>
            <input
              type='text'
              placeholder='Pretraži korisnike...'
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className={classes.input}
            />
          </div>
          <div className={classes.postContainer}>
            {filteredUsers.map((user) => (
              <AdminSingleUser user={user} key={user._id} />
            ))}
          </div>
        </>
      )}
    </div>
  )
}

export default SviKorisnici
